export const NETWORK_RESET_STATE = 'NETWORK_RESET_STATE';
export const NETWORK_CURRENT_ITEM = 'NETWORK_CURRENT_ITEM';

export const NETWORK_REQUEST_LOADING = 'NETWORK_REQUEST_LOADING';
export const NETWORK_REQUEST_SUCCESS = 'NETWORK_REQUEST_SUCCESS';
export const NETWORK_REQUEST_FAILED = 'NETWORK_REQUEST_FAILED';

export const NETWORK_CURRENT_ACTION = 'NETWORK_CURRENT_ACTION';
export const NETWORK_RESET_ACTION = 'NETWORK_RESET_ACTION';